
import BaseCmsBlock from "../../node_modules/sitis-nuxt/lib/cms/CmsBlockMixin";
import { scrollWatcher } from '~/helpers/scroll-watcher.js';
import {homePageWatcher} from "~/helpers/is-main-page";

export default BaseCmsBlock.extend({
  name: "BenefitsWorkingWithUsBlock",

  data: function () {
    return {
      isOpenFullMessage: false,
      isVisibleButtonMoreMessage: false,
      isAnimate: false,
    }
  },

  components: {
    BenefitCard: () => import("./components/BenefitsWorkingWithUsBlock/BenefitCard")
  },

  mounted: function () {
    this.initMessage();
    document.addEventListener('scroll', this.inFieldOfView);
  },

  unMounted: function () {
    document.removeEventListener('scroll', this.inFieldOfView);
  },

  computed: {
    isHome: function () {
      return homePageWatcher(this.$route.fullPath);
    },
  },

  methods: {
    initMessage: function () {
      if (!this.$refs.refRootMessage) {
        return
      }

      const rootHeight = this.$refs.refRootMessage.clientHeight;
      const fullHeight = this.$refs.refFullMessage.clientHeight;
      if (fullHeight <= rootHeight) {
        return;
      }

      this.isVisibleButtonMoreMessage = true;
    },
    openCloseFullMessage: function () {
      this.isOpenFullMessage = !this.isOpenFullMessage;
    },
    inFieldOfView: function () {
      if (scrollWatcher('benefits-working')) {
        document.removeEventListener('scroll', this.inFieldOfView);
        this.isAnimate = true;
      }
    },
  }
})
